<template lang="html">
    <section class="delete-count-down">
        <h1>PROCHAINES PÉRIODES PROMO</h1>
        <div class="countdown-list">
            <div v-if="getCountDownNext.length <= 0" class="listEmpty">{{ $t("countdown.emptycntd") }}</div>
            <div v-if="getCountDownNext.length > 0">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">{{ $t("countdown.colname") }}</th>
                            <th scope="col">{{ $t("countdown.colstartdate") }}</th>
                            <th scope="col">{{ $t("countdown.colenddate") }}</th>
                            <th scope="col">{{ $t("countdown.colstanddesign") }}</th>
                            <th scope="col">{{ $t("countdown.colbrand") }}</th>
                            <th scope="col">{{ $t("countdown.colcreateupdate") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="countDown in getCountDownNext">
                            <td class="name">{{ countDown.name }}</td>
                            <td>
                                {{ convertGmtToLocal(new Date(countDown.startDate)).toLocaleString() }} <br />
                                <span class="utcForamt">({{ countDown.startDate }} UTC)</span>
                            </td>
                            <td>
                                {{ convertGmtToLocal(new Date(countDown.endDate)).toLocaleString() }} <br />
                                <span class="utcForamt">({{ countDown.endDate }} UTC)</span>
                            </td>
                            <td>{{ countDown.standDesign.name }}</td>
                            <td>{{ countDown.standDesign.brand.name }}</td>
                            <td>
                                <span class="dateAction"
                                    >Created : {{ new Date(countDown.createdAt).toLocaleString() }} <br />
                                    by {{ countDown.modifiedBy.firstname }} {{ countDown.modifiedBy.lastname }}</span
                                >
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- pre>{{ getCountDownNext }}</pre -->
    </section>
</template>

<script lang="js">
import {mapActions, mapGetters} from 'vuex'
// import Globals from '../../../../components/globals'
// import httpService from '../../../../components/service'

export default {
    name: 'listNextCountdown',
    props: [
        'action'
    ],
    mounted () {
    },
    data () {
        return {}
    },
    methods: {
        ...mapActions({
            listCountDown: 'countdown/listCountDown'
        }),
        /**
         * Convert Date GTM to Local
         * @param dateGmt
         * @returns {Date}
         */
        convertGmtToLocal (dateGmt) {
            let newDate = new Date(dateGmt.getTime() + dateGmt.getTimezoneOffset() * 60000)

            let offset = dateGmt.getTimezoneOffset() / 60
            let hours = dateGmt.getHours()

            newDate.setHours(hours - offset)

            return newDate
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'defaultModal')
        }
    },
    computed: {
        ...mapGetters({
            getCountDownNext: 'countdown/getCountDownNext'
        })
    }
}
</script>

<style scoped lang="scss">
.delete-count-down {
}
</style>



// WEBPACK FOOTER //
// ListNextCountDown.vue?52ba36b2